import { opaquePublicIdSchema } from '@ballpeek/api/client'
import { createFileRoute } from '@tanstack/react-router'

import { TeamHistoryPage } from '~/features/football-history/history-pages'
import { teamHistoryQueryOptions } from '~/features/football-history/query-options'
import {
  parseTeamHistorySearch,
  teamHistorySearchSchema,
} from '~/features/football-history/search-schema'
import { parsePublicFootballRouteInput } from '~/lib/public-football-read'
import { seo } from '~/utils/seo'

export const Route = createFileRoute('/_public/teams/$teamId_/history')({
  validateSearch: search => parseTeamHistorySearch(search, 'en'),
  beforeLoad: ({ params }) => {
    parsePublicFootballRouteInput(opaquePublicIdSchema, params.teamId)
  },
  head: ({ params }) => seo({
    title: 'Team historical matches | BallPeek',
    description: 'Bounded descriptive football match history with explicit archive coverage.',
    pathname: `/teams/${encodeURIComponent(params.teamId)}/history`,
    locale: 'en',
  }),
  loader: async ({ context, params, location }) => {
    await context.queryClient.prefetchQuery(
      teamHistoryQueryOptions(params.teamId, teamHistorySearchSchema.parse(location.search)),
    )
  },
  component: TeamHistoryRoute,
})

function TeamHistoryRoute() {
  return <TeamHistoryPage teamId={Route.useParams().teamId} search={Route.useSearch()} />
}
